<div
  #headerDiv
  class="header"
  [ngClass]="isLiveChat ? 'lc-header' : 'va-header'"
  [style]="getHeaderStyles()"
>
  <!-- Left side -->
  <div class="header-logo-container">
    <img src="{{ logo }}" alt="logo" class="header-logo" />
    <span class="header-title">{{ headerTitle }}</span>
  </div>

  <!-- Right side -->
  <div class="right-container">
    <ds-icon
      [name]="'settings'"
      (click)="toggleMenu()"
      [ngClass]="{ open: isMenuOpen, lc: isLiveChat }"
      [title]="settingsTitle"
      class="va-header-button settings"
    >
    </ds-icon>
    <ds-icon
      [name]="'dash'"
      (click)="onMinimize()"
      [ngClass]="{ lc: isLiveChat }"
      [title]="minimizeTitle"
      class="va-header-button minimize"
    >
    </ds-icon>
    <ds-icon
      [name]="'close'"
      (click)="onClose()"
      [ngClass]="{ lc: isLiveChat }"
      [title]="closeTitle"
      class="va-header-button close"
    >
    </ds-icon>
  </div>

  <!-- Dropdown menu -->
  <div class="dropdown-content" *ngIf="isMenuOpen">
    <ng-container *ngFor="let menuItem of menuItems; let i = index">
      <ucx-header-menu-item
        class="menu-item"
        [menuItemText]="menuItem.menuItemText"
        [menuItemLabel]="menuItem.menuItemLabel"
        [menuItemKey]="menuItem.menuItemKey"
        [menuItemType]="menuItem.menuItemType"
        [menuItemOptions]="menuItem.menuItemOptions"
        [selectedMenuItemOption]="menuItem.selectedMenuItemOption"
        (menuItemChanged)="onSelectMenuItem($event)"
        [isMenuItemVisible]="menuItem.isMenuItemVisible"
      ></ucx-header-menu-item>
      <hr *ngIf="i !== menuItems.length - 1" />
    </ng-container>
    <div class="version">{{ version }}</div>
  </div>
</div>
<!-- Overlay-backdrop -->
<ucx-overlay-backdrop
  *ngIf="isMenuOpen"
  [customTop]="64"
></ucx-overlay-backdrop>
